import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";
import {DeviceDraftDTO} from "./GatewayPendingConfigPayloadDTO";

class O {
  gatewayId!: number;
  updateTs?: string;
  device!: DeviceDraftDTO;
}

class I {
  gatewayId!: number;
  deviceId!: number;
  name!: string;
}

export class DuplicateDevicePendingConfigCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(GatewayPendingConfigOPEEnum.DuplicateDevicePendingConfig);
    this.i = new I();
    this.o = new O();
  }
}
